<template>
  <a-modal v-model="modal" title="新建" width="500px" :maskClosable="false" :closable="false">
    <div class="create-material" v-if="modal">
      <a-form-model :model="formData" ref="form" :rules="rules">
        <a-form-model-item
          label="加工组织"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="organizationCode"
        >
          <global-select
            v-model="formData.organizationCode"
            v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
            selectType="selectAssemble"
            :selectData="inventOrg"
            :disabled="isDisableOrganization"
            :selectItem="{ value: 'realValue', label: 'label' }"
            :assembleLabel="true"
            @change="inventOrgValueOnChange"
          />
        </a-form-model-item>
        <a-form-model-item
          label="班组编码"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="teamCode"
        >
          <a-input v-model="formData.teamCode" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="班组名称"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="teamName"
        >
          <a-input v-model="formData.teamName" placeholder="请输入" :maxLength="40" />
        </a-form-model-item>
        <a-form-model-item
          label="所属车间"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="workshopCode"
        >
          <global-select
            :value.sync="formData.workshopCode"
            :selectData="workshopList"
            selectType="selectAssembleFilter"
            :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
          />
        </a-form-model-item>
        <a-form-model-item
          label="定编人数"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="quota"
        >
          <a-input-number v-model="formData.quota" style="width: 100%" :precision="0" :min="1"/>
        </a-form-model-item>
        <a-form-model-item
          label="备注"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="remark"
        >
          <a-input v-model="formData.remark" placeholder="请输入" :maxLength="100" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'

import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import { apiTeamUpdate } from '@/api/mes/productionPrepare/teamManage'

export default {
  name: 'CreateModal',
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
  },
  data() {
    return {
      modal: false,
      formData: {
        organizationCode: '', //  组织
        workshopCode: '', //  所属车间
        teamName: '', // 班组名称
        teamCode: '', // 班组编码
        quota: '', // 定编人数
        remark: '' // 备注
      },
      loading: false,
      rules: {
        organizationCode: [{ required: true, message: ' ', trigger: 'change' }],
        workshopCode: [{ required: true, message: ' ', trigger: 'change' }],
        teamName: [{ required: true, message: ' ', trigger: 'change' }],
        teamCode: [{ required: true, message: ' ', trigger: 'change' }]
      },
      workshopList: [] // 车间列表
    }
  },
  methods: {
    // 初始化
    show () {
      this.$set(this.formData, 'organizationCode', this.organizationCodeOrigin)
      this.$set(this.formData, 'workshopCode', '')
      this.$set(this.formData, 'teamName', '')
      this.$set(this.formData, 'teamCode', '')
      this.$set(this.formData, 'quota', '')
      this.$set(this.formData, 'remark', '')
      this.modal = true
    },
    // 确认创建
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiTeamUpdate(this.formData).then(res => {
            if (res?.code === 200) {
              this.$message.success('创建成功')
              this.$emit("refresh")
              this.modal = false
            } else {
              this.$message.error(res?.msg || '创建失败')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.formData.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
